import { render, staticRenderFns } from "./Metrica.vue?vue&type=template&id=4a38505e&scoped=true"
import script from "./Metrica.vue?vue&type=script&lang=js"
export * from "./Metrica.vue?vue&type=script&lang=js"
import style0 from "./Metrica.vue?vue&type=style&index=0&id=4a38505e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38505e",
  null
  
)

export default component.exports